var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { useRequest } from '../../../hooks/requestHook';
import useFetch from '../../../hooks/useFetch';
import { preOrderRequest as api } from '../../../api';
import qs from 'qs';
import { usePreOrderRequestGroupColumns } from '../../../hooks/useColumns';
import MaterialTable from '../../MaterialTable';
import OfferPreOrderRequestTable from './OfferPreOrderRequestTable';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var PreOrderRequestedContent = function (_a) {
    var producer = _a.producer;
    var preOrderRequestColumns = usePreOrderRequestGroupColumns('admin');
    var getAll = useRequest(api.getAllGroupByOfferListAndOffer);
    var fetchPreOrderRequests = useFetch({
        buildFilterParams: function () {
            return { offer_list_producer_id_eq: producer.id };
        },
        api: getAll,
    });
    var query = qs.parse(location.search.slice(1));
    var initialPage = parseInt((query.page || '')) || 0;
    var pageSize = parseInt((query.pageSize || '')) || 25;
    var columns = React.useMemo(function () { return [
        preOrderRequestColumns.offerListName,
        preOrderRequestColumns.lotNumber,
        preOrderRequestColumns.processing,
        preOrderRequestColumns.variety,
        preOrderRequestColumns.totalWeight,
    ]; }, [preOrderRequestColumns]);
    var detailPanel = React.useCallback(function (_a) {
        var rowData = _a.rowData;
        return (React.createElement(OfferPreOrderRequestTable, { offerList: rowData.offerList, offer: rowData.offer }));
    }, []);
    return (React.createElement(Wrapper, null,
        React.createElement(MaterialTable, { model: "preOrderRequestGroup", columns: columns, detailPanel: detailPanel, data: fetchPreOrderRequests, options: {
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
            } })));
};
export default PreOrderRequestedContent;
var templateObject_1;
